import { render, staticRenderFns } from "./PublicResume.vue?vue&type=template&id=56b96ffc&"
import script from "./PublicResume.vue?vue&type=script&lang=js&"
export * from "./PublicResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports